module.exports = __webpack_public_path__ + "static/img/mirror_detail.db1c7a35.png";